import { render, staticRenderFns } from "./Affiliate2AffSubTags.vue?vue&type=template&id=e83846c6"
import script from "./Affiliate2AffSubTags.vue?vue&type=script&lang=js"
export * from "./Affiliate2AffSubTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports